<template>
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'750px'"
    :classDialog="'dialog-doc-out-finish'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #header>
      <h2 class="text-center font-semibold mb-4 margin-top-15">Danh sách chứng thư số</h2>
    </template>

    <template #body>
      <el-table
        ref="multipleTable"
        :data="dataCert"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :row-key="(row) => row.serial_number"> <!-- Use a unique key if necessary -->

        <el-table-column
          type="selection"
          width="55">
        </el-table-column>

        <el-table-column
          property="serial_number"
          label="Serinal Number"
          width="120">
        </el-table-column>

        <el-table-column
          property="subject"
          label="Người sở hữu"
          width="150">
        </el-table-column>

        <el-table-column
          property="address"
          label="Đơn vị cấp"
          width="120"
          show-overflow-tooltip>
        </el-table-column>

        <el-table-column
          label="Thời gian hiệu lực"
          width="200">
          <template slot-scope="scope">
            {{ scope.row.startDate }} - {{scope.row.endDate}}
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
          <el-button
            class="btn__cancel btn-none__border"
            @click="$emit('closeDialog')"
          >
            <i class="fal fa-times"></i>
            &nbsp;Hủy
          </el-button>
          <el-button
            type="success"
            size="mini"
            class="addDocs  color__white bg__blue btn-none__border"
            @click="save"
            :disabled="!idSelection"
          >
            <i :class="['fas fa-check-circle font-size__small']"></i>
            &nbsp;Xác nhận
          </el-button>
        </div>
    </template>
  </custom-dialog>
</template>
<script>
  // import constants from "../../../constants";
  import CustomDialog from "../../common/custom-dialog";
  // import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
  // import {EventBus} from "../../../event-bus.js";

  export default {
    name: "DocOutKetThucChungThuSo",
    props: ["isOpen", "vbOutgoingProcessId", "docId", "vbAttachmentId", "dataCert"],
    components: {CustomDialog},

    computed: {
    },

    data() {
      return {
        tableData: [],
        multipleSelection: [],
        idSelection: null,
      };
    },

    created() {
    },

    methods: {

      handleSelectionChange(selection) {
        console.log('selection',selection)
        if (selection.length > 1) {
          // Keep only the latest selected row
          const lastSelected = selection[selection.length - 1];
          this.$refs.multipleTable.clearSelection();
          this.$refs.multipleTable.toggleRowSelection(lastSelected, true);
          this.selectedRow = lastSelected;
        } else if (selection.length === 1){
          this.selectedRow = selection[0];
        } else {
          this.selectedRow = null;
        }
        this.idSelection = this.selectedRow ? this.selectedRow.serial_number : null;
      },


      async save() {
        this.$emit("success", {idSelection: this.idSelection});
        // this.$emit('closeDialog')
      }

    }
  };
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/DocOutKetThucCTS.vue